import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useApi } from "../hooks/useApi";
import { formatKpiValue, pctDelta, formatDelta } from "../lib/format";
const ACCENT = "var(--accent)";
const INK = "var(--ink)";
const PAPER_3 = "var(--paper-3)";
function Sparkline({ data, accent = false }) {
    const w = 92, h = 28;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const span = max - min || 1;
    const pts = data.map((v, i) => {
        const x = (i / (data.length - 1)) * (w - 2) + 1;
        const y = h - 2 - ((v - min) / span) * (h - 4);
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    });
    const lineColor = accent ? ACCENT : INK;
    const fillColor = accent ? "var(--accent-soft)" : PAPER_3;
    const areaPath = `M${pts[0]} L${pts.join(" L")} L${w - 1},${h - 1} L1,${h - 1} Z`;
    const linePath = `M${pts[0]} L${pts.join(" L")}`;
    const lastPt = pts[pts.length - 1].split(",");
    return (_jsxs("svg", { width: w, height: h, className: "spark", "aria-hidden": "true", children: [_jsx("path", { d: areaPath, fill: fillColor, opacity: "0.6" }), _jsx("path", { d: linePath, stroke: lineColor, strokeWidth: "1.25", fill: "none", strokeLinejoin: "round", strokeLinecap: "round" }), _jsx("circle", { cx: lastPt[0], cy: lastPt[1], r: "2", fill: lineColor })] }));
}
export default function KPIs({ period, stores }) {
    const storesParam = stores.length && !stores.includes("all")
        ? `&stores=${stores.join(",")}`
        : "";
    const { data, isLoading, error } = useApi(`/api/app/kpis?period=${period}${storesParam}`);
    if (isLoading) {
        return (_jsx("div", { className: "kpis", children: Array.from({ length: 5 }).map((_, i) => (_jsxs("div", { className: "kpi", children: [_jsx("div", { className: "lab", style: { height: 11, background: "var(--paper-3)", borderRadius: 2, width: 80 } }), _jsx("div", { className: "val", style: { height: 38, background: "var(--paper-3)", borderRadius: 2, marginTop: 8, width: 120 } })] }, i))) }));
    }
    if (error || !data)
        return null;
    return (_jsx("div", { className: "kpis", children: data.kpis.map((k) => {
            const v = formatKpiValue(k.value, k.format);
            const d = pctDelta(k.value, k.prev_value);
            const pos = d >= 0;
            return (_jsxs("div", { className: "kpi", children: [_jsxs("div", { className: "lab", children: [k.label, k.unit ? ` · ${k.unit}` : ""] }), _jsxs("div", { className: "val", children: [v.whole, v.unit && _jsx("span", { className: "unit", children: v.unit })] }), _jsxs("div", { className: `delta ${pos ? "pos" : "neg"}`, children: [_jsx("span", { className: "pct", children: formatDelta(d) }), _jsx("span", { className: "vs", children: "vs. last year" })] }), k.spark && _jsx(Sparkline, { data: k.spark, accent: k.key === "rev" })] }, k.key));
        }) }));
}
